export default function XStream(props: any) {
    return (
        <svg width="46" height="25" viewBox="0 0 46 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9.59753 11.5781H12.4738L6.1958 19.6429L16.3415 10.5724H13.4671L17.4154 6.5H13.6608L9.59753 11.5781Z" fill="black" />
            <path d="M4.3912 15.1818H5.75074L3.1237 10.5723H1.76416L4.3912 15.1818Z" fill="black" />
            <path d="M1.4861 15.1813L3.28667 13.789L2.82838 12.9775L0 15.1813H1.4861Z" fill="black" />
            <path d="M5.98491 10.5723L4.19775 11.9532L4.67714 12.7437L7.52278 10.5723H5.98491Z" fill="black" />
            <path d="M9.5129 13.3966L9.88298 12.3643H6.34128L5.97119 13.3966H9.5129Z" fill="black" />
            <path d="M16.9126 10.5723L16.533 11.6046H18.694L17.3824 15.1818H18.4428L19.7544 11.6046H21.9155L22.2971 10.5723H16.9126Z" fill="black" />
            <path
                d="M37.2523 10.5723H36.1823L36.1554 10.6046C35.8908 10.9196 35.6722 11.1672 35.4996 11.3475L32.1056 15.1818H33.3654L36.2705 11.9437L36.7882 15.1818H37.9599L37.3846 11.4275L37.2638 10.6504L37.2523 10.5723Z"
                fill="black"
            />
            <path
                d="M41.72 13.8485L40.7708 10.5723H39.9099L38.2167 15.1818H39.2771L40.209 12.6389L40.6884 14.3532L40.8801 15.1151L40.8974 15.1837H41.6644L41.6913 15.1589L42.4334 14.4237L44.1591 12.7285L43.2464 15.1818H44.3068L46 10.5723H45.0777L41.72 13.8485Z"
                fill="black"
            />
            <path
                d="M27.7967 10.5723H22.8321L22.4525 11.6046H26.3317L26.0517 12.3646H22.1687L21.1409 15.1818H22.1994L22.8571 13.397H24.1859L25.3691 15.1818H26.6922L25.5723 13.397H26.7286L27.7468 10.6942L27.7967 10.5723Z"
                fill="black"
            />
            <path d="M26.9189 15.1819H31.9026L32.2804 14.1553H27.2948L26.9189 15.1819Z" fill="black" />
            <path d="M33.214 11.6046L33.5956 10.5723H28.6099L28.2322 11.6046H29.3156H33.214Z" fill="black" />
            <path d="M27.5745 13.3966H32.5601L32.9302 12.3643H29.0337H27.9522L27.5745 13.3966Z" fill="black" />
        </svg>
    );
}
